import Alert from '../components/Alert'
export default options => {
  const defaultTimeout = options >= 0 ? options : 3000
  const timeout = {
    error: options?.error || defaultTimeout,
    warn: options?.warn || defaultTimeout,
    info: options?.info || defaultTimeout
  }
  return {
    components: {
      alert: Alert
    },

    data () {
      return {
        alert: {
          text: '',
          show: false,
          color: 'error',
          timeout: 0
        }
      }
    },

    computed: {
      showError: {
        get () {
          return this.alert.show
        },
        set (val) {
          Object.assign(this.alert, {
            color: 'error',
            text: val,
            show: !!val,
            timeout: timeout.error
          })
        }
      },
      showInfo: {
        get () {
          return this.alert.show
        },
        set (val) {
          Object.assign(this.alert, {
            color: 'info',
            text: val,
            show: !!val,
            timeout: timeout.info
          })
        }
      },
      showWarn: {
        get () {
          return this.alert.show
        },
        set (val) {
          Object.assign(this.alert, {
            color: 'warning',
            text: val,
            show: !!val,
            timeout: timeout.warn
          })
        }
      }
    }
  }
}
